import { useContext } from 'react';
import { FormattedMessage } from 'react-intl';

import { CodeSnippet } from '../../../content/code-snippet/CodeSnippet.js';
import { InformationOverlay } from '../../../content/information-overlay/InformationOverlay.js';
import { useId } from '../../../core/hooks/useId.js';
import { Flex } from '../../../layouts/flex/Flex.js';
import { Text } from '../../../typography/text/Text.js';
import { NotificationSettingsContext } from '../contexts/NotificationSettingsContext.js';
import { notificationMessages } from '../messages.js';

/** @internal */
export function NotificationPermissionInfo() {
  const { hasReadPermission, enabled } = useContext(
    NotificationSettingsContext,
  );

  const informationOverlayContentId = useId();

  if (hasReadPermission) {
    return null;
  }

  return (
    <InformationOverlay aria-labelledby={informationOverlayContentId}>
      <InformationOverlay.Content id={informationOverlayContentId}>
        <Flex flexDirection="column">
          <Flex flexDirection="column" gap={0}>
            <Text textStyle="base-emphasized">
              <FormattedMessage
                {...notificationMessages.noPermissionsHeading}
                values={{
                  notificationEnabled: enabled,
                }}
              />
            </Text>
            <Text textStyle="base">
              <FormattedMessage {...notificationMessages.copyPermissions} />:
            </Text>
          </Flex>
          <CodeSnippet showLineNumbers={false} language="json" lineBreaks>
            notification:notifications:read
          </CodeSnippet>
        </Flex>
      </InformationOverlay.Content>
    </InformationOverlay>
  );
}
